<template>
  <div>
    <div class="animated fadeIn faster">
      <h4>Booker Results</h4>
      <div class="row mx-2">
        <div class="col-md-12 px-0">
          <div
            class="container-fluid w-100 p-2 border bg-white rounded stats-wrapper"
          >
            <div class="d-flex flex-wrap">
              <div class="w-50 input-group input-group-sm p-1">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >From</span
                  >
                </div>
                <date-picker
                  id="startDatePicker"
                  class="form-control"
                  v-model="range.startDate"
                  :config="datePickerConfig"
                  placeholder="Start Date"
                ></date-picker>

                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >To</span
                  >
                </div>
                <date-picker
                  id="startDatePicker"
                  class="form-control"
                  v-model="range.endDate"
                  :config="datePickerConfigEndDate"
                  placeholder="Start Date"
                ></date-picker>
              </div>

              <div
                class="w-25 input-group input-group-sm p-1 treeselect-wrapper"
                v-if="
                  dashboardType == 'bdr' &&
                  ['1', '9'].includes(currentUser.role_id)
                "
              >
                <div class="input-group-prepend">
                  <span class="input-group-text" id="inputGroup-sizing-sm"
                    >BDR</span
                  >
                </div>
                <treeselect
                  v-model="bdr_user_id"
                  :options="bdr_users"
                  :multiple="false"
                  :clearable="false"
                  :normalizer="normalizeOptions"
                  class="form-control inline-table"
                  @change="changeBDR"
                >
                </treeselect>
              </div>

              <button
                class="btn btn-success"
                @click="loadRangeStats()"
                style="width: 20%"
              >
                <i class="icon-calendar-check-o mr-2"></i>
                <small>
                  {{ $t("lang.button.filter") }}
                </small>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        v-for="chart in chartInfo"
        class="row mt-3"
        v-if="loadChart.indexOf(chart.name) >= 0"
      >
        <div class="col-md-12" v-if="bdr_user_id">
          <MonitorBarChart
            :title="chart.title"
            :key="chart2"
            :range="range"
            :method="chart.name"
            :userId="
              dashboardType == 'bdr' &&
              ['1', '9'].includes(currentUser.role_id) &&
              bdr_user_id
                ? Number(bdr_user_id)
                : 0
            "
          />
        </div>
        <div class="row justify-content-center w-100" v-else>
          <div class="alert alert-primary mx-5 my-2 px-5 py-4">
            <h6>
              <i class="fas fa-exclamation-triangle mr-2"></i>
              Select a BDR to see the performance
            </h6>
          </div>
        </div>
      </div>

      <div v-if="false && currentUser.role_id > 1">
        <h3 class="mt-5">{{ $t("lang.label.commissions-real") }}</h3>
        <UsageStats tableType="bdr-commissions-real" />
      </div>
    </div>
  </div>
</template>
<script>
import { statusBadgeMixin, statusPointMixin } from "@/_mixins/";
import { mapState, mapActions } from "vuex";
import { router } from "@/_helpers";
import moment from "moment";
import Header from "@/components/Header.vue";
import LineChart from "@/components/Chart.vue";
import BubbleChart from "@/components/BubbleChart.vue";
import DoughnutChart from "@/components/DoughnutChart.vue";
import RadarChart from "@/components/RadarChart.vue";
import BarChart from "@/components/BarChart.vue";
import UsageStats from "@/components/Usages/UsageStats.vue";
import {
  businessContactService,
  opportunitiesService,
  usersService,
  campaignsService,
  categoriesService,
} from "@/_services";
import { monitorService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import MonitorBarChart from "@/components/Dashboard/Monitor/Barchart.vue";
import CampaignStatistics from "@/components/Campaigns/CampaignStatistics.vue";
import MyCampaign from "@/components/Campaigns/MyCampaign.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  data() {
    return {
      selectUserBdr: false,
      bdr_user_id: 1,
      bdr_users: null,
      allOption: { id: 1, name: this.$t("lang.label.all") },
      bdrCommissions: [],
      checkBilling: false,
      currentPage: 1,
      cantPerPage: 50,
      chart1: 100,
      chart2: 200,
      loadChart: ["taskshour"],
      chart3: 300,
      cantPerPageOptions: [5, 10, 20, 50, 100],
      selected: [],
      selectedSearch: [],
      selectedGoogle: [],
      searchFilter: "",
      day: "",
      date: "",
      chartInfo: [],
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        // minDate: moment().startOf("day")
        maxDate: moment().endOf("day"),
      },
      datePickerConfigEndDate: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        maxDate: moment().endOf("day"),
      },

      range: {
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
    };
  },

  props: {
    selCampaignId: String,
    selectedCampaignName: String,
    userId: Number,
    dashboardType: {
      type: String,
      default: null,
    },
  },

  components: {
    BubbleChart,
    RadarChart,
    BarChart,
    DoughnutChart,
    LineChart,
    LoadingSpinner,
    MonitorBarChart,
    UsageStats,
    Treeselect,
  },

  mixins: [statusBadgeMixin, statusPointMixin],

  mounted() {
    if (this.model !== undefined && this.model.campaign_status_id == 3) {
      this.range.endDate = this.model.campaign_status_date;
    }
  },
  updated() {},

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },

    ...mapState({
      currentUser: (state) => state.authentication.user,
      stats: (state) => state.campaigns.stats.data,
      model: (state) => state.campaigns.selected.data,
      loadingContacts2: (state) => state.contacts.loading,
      contacts2: (state) => state.contacts.all2.data,
      headerTab: (state) => state.header.tab,
    }),

    isBdrUser() {
      if (this.user.team_role_id == 2 && this.user.role_id == 2) {
        this.bdr_user_id = this.currentUser.id;
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {},

  created() {
    if (this.userId && this.dashboardType !== "bdr") {
      this.chartInfo = [
        {
          name: "taggedgroup",
          title: "Group Tags",
        },
        {
          name: "taskshour",
          title: this.$t("lang.label.tasks"),
        },
        {
          name: "taskshouranswer",
          title: "Email answer",
        },
        {
          name: "taskshourcall",
          title: "Calls",
        },
        {
          name: "tagged",
          title: "Tags",
        },
      ];
    } else if (this.isBdrUser) {
      (this.loadChart = ["bdr-performance"]),
        (this.chartInfo = [
          // {
          //   name: "bdr-commissions",
          //   title: this.$t("lang.label.bdr-commissions"),
          // },
          // {
          //   name: "bdr-objective",
          //   title: this.$t("lang.label.bdr-objective"),
          // },
          {
            name: "bdr-performance",
            title: this.$t("lang.label.bdr-performance"),
          },
        ]);
    } else if (
      this.dashboardType === "bdr" &&
      ["1", "9"].includes(this.currentUser.role_id)
    ) {
      this.getUserBdr();

      (this.loadChart = ["bdr-performance"]),
        (this.chartInfo = [
          // {
          //   name: "bdr-commissions",
          //   title: this.$t("lang.label.bdr-commissions"),
          // },
          // {
          //   name: "bdr-objective",
          //   title: this.$t("lang.label.bdr-objective"),
          // },
          {
            name: "bdr-performance",
            title: this.$t("lang.label.bdr-performance"),
          },
        ]);
      // al setear el valor del select se actualiza automaticamnete
      this.bdr_user_id = 1;
    } else {
      this.chartInfo = [
        {
          name: "taskshour",
          title: this.$t("lang.label.tasks"),
        },
      ];
    }
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),

    ...mapActions("campaigns", {
      getCampaignStatsByIdAndRange: "getStatsByIdAndRange",
    }),

    ...mapActions("contacts", {
      getAll2Contacts: "getAll2",
    }),
    loadMoreChart(type) {
      this.loadChart = [];
      this.loadChart.push(type);
    },
    loadaxis() {
      this.chart1++;
      this.chart2++;
      this.chart3++;
    },

    changeBDR() {
      this.chart2++;
    },

    getUserBdr() {
      usersService
        .getBdrs()
        .then((res) => {
          this.bdr_users = [this.allOption, ...res.result];
        })
        .catch((err) => consolelog(err));
    },

    normalizeOptions(node) {
      return {
        id: node.id,
        label: node.name,
      };
    },

    getStatus() {
      if (this.model.campaign_status_id == 2) return "Active";

      if (this.model.campaign_status_id == 1) return "Pending";

      if (this.model.campaign_status_id == 3) return "Stopped";
    },

    getDataUserBilling() {
      this.checkBilling = this.checkPaymentMethodAndBudget();
    },
    alertShowCampaign() {
      this.$swal({
        type: "warning",
        title: "De nouvelles opportunités vous attendent !",
        text: "De nouvelles opportunités ont été générées depuis la fin de votre essai. Félicitations! Pour les découvrir, complétez votre profil de facturation dans la section dédiée à cet effet.",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.label.addpaymentmethod"),
      }).then((result) => {
        if (result.value) {
          this.$router.push("/settings-account");
        }
      });
    },

    getContacts2() {
      // this.searchContacts2();
    },
    getsessionrate() {
      return this.getPercentage(
        this.stats.activity.activity_total,
        this.stats.activity.emails_sent
      );
    },
    getanswerrate() {
      return this.getPercentage(
        this.stats.activity.email_response_total,
        this.stats.activity.emails_sent
      );
    },
    getopenrate() {
      return this.getPercentage(
        this.stats.activity.emails_opened,
        this.stats.activity.emails_sent
      );
    },
    getbouncerate() {
      return this.getPercentage(
        this.stats.activity.bounce_total,
        this.stats.activity.emails_sent
      );
    },
    getPercentage(fraction, total) {
      if (total == 0) {
        return "-%";
      } else {
        var result = (fraction / total) * 100;
        result = parseFloat(result).toFixed(0);
        return result + "%";
      }
    },

    searchContacts2() {
      if (this.selCampaignId != undefined) {
        this.getAll2Contacts({
          currentPage: this.currentPage,
          cantPerPage: this.cantPerPage,
          searchFilter: this.searchFilter,
          campaignId: this.selCampaignId != undefined ? this.selCampaignId : 0,
        });
      }
    },

    searchContacts2WithPageReset() {
      this.getAll2Contacts({
        currentPage: this.currentPage,
        cantPerPage: this.cantPerPage,
        searchFilter: this.searchFilter,
        campaignId: this.selCampaignId != undefined ? this.selCampaignId : 0,
      }).then((result) => (this.currentPage = 1));
    },

    validarDate() {
      let startDate = new Date(this.range.startDate);
      let endDate = new Date(this.range.endDate);
      if (startDate.getTime() > endDate.getTime()) {
        return true;
      } else {
        return false;
      }
    },

    formatLastMailDate(date) {
      return date.split(" ")[0];
    },

    loadRangeStats() {
      if (this.validarDate() === true) {
        this.$swal({
          type: "warning",
          title: "Error!",
          text: "Start date should be less than end date. ",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Close",
        });
      } else {
        this.loadaxis();
      }
    },
  },
};
</script>
<style>
.status-colors.positive {
  color: #61de4d;
}
.status-colors.paused {
  color: #babac2;
}
.status-colors.stopped {
  color: #ff6584;
}
.eff-blur {
  z-index: 20;
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;

  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  filter: blur(3px);
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
}
.eff-blur + div.effect-blur .table-responsive {
  filter: blur(3px);
  -webkit-filter: blur(3px);
  -moz-filter: blur(3px);
  -o-filter: blur(3px);
  -ms-filter: blur(3px);
}
</style>
